import React from "react";
import styles from "./Sponsors.module.css";

type Sponsor = {
  name: string;
  logoSrc: string;
  href?: string;
};

type Props = {
  headline?: string;
  mainSponsors: Sponsor[];
  sponsorsRow2: Sponsor[];
  sponsorsRow3: Sponsor[];
};

function SponsorLogo({
  sponsor,
  variant,
}: {
  sponsor: Sponsor;
  variant: "main" | "secondary";
}) {
  const imgClass =
    variant === "main" ? styles.logoMain : styles.logoSecondary;

  const img = (
    <img
      src={sponsor.logoSrc}
      alt={`${sponsor.name} Logo`}
      className={imgClass}
      loading="lazy"
      decoding="async"
    />
  );

  if (sponsor.href) {
    return (
      <a
        className={styles.logoLink}
        href={sponsor.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Zur Website von ${sponsor.name}`}
      >
        {img}
      </a>
    );
  }

  return <div className={styles.logoBox}>{img}</div>;
}

export const SponsorsGrid: React.FC<Props> = ({
  mainSponsors,
  sponsorsRow2,
  sponsorsRow3,
}) => {
  return (
    <section className={styles.section}>

      <div className={styles.rowMain}>
        {mainSponsors.slice(0, 3).map((s) => (
          <div key={s.name} className={styles.itemMain}>
            <SponsorLogo sponsor={s} variant="main" />
          </div>
        ))}
      </div>

      <div className={styles.rowSecondary}>
        {sponsorsRow2.slice(0, 4).map((s) => (
          <div key={s.name} className={styles.itemSecondary}>
            <SponsorLogo sponsor={s} variant="secondary" />
          </div>
        ))}
      </div>

      <div className={styles.rowSecondary}>
        {sponsorsRow3.slice(0, 5).map((s) => (
          <div key={s.name} className={styles.itemSecondary}>
            <SponsorLogo sponsor={s} variant="secondary" />
          </div>
        ))}
      </div>
    </section>
  );
};
